import { createContext } from "react";
import { NamedProperty } from "sprint-common-web";

import { VersionType } from "../../../../common/data/lookup-data-providers/VersionTypesDataProvider";
import { MovieDetails, MovieVersionDetails } from "../MovieDetails";

interface IMovieContext {
    movie: MovieDetails;
    isLoading: boolean;
    addMovieVersion(movieVersion: MovieVersionDetails): void;
    updateMovieVersion(versionId: string, distirbutor: NamedProperty, type: VersionType): void;
    setMovieDetails(title: string, year?: number): void;
    setVersionAsMerged(versionId: string, mergedTargetId: string): void;
}

const defaultMovieContext: IMovieContext = {} as IMovieContext;

export const MovieContext = createContext<IMovieContext>(defaultMovieContext);
